import { ContainerBox as Boxes, type ContainerBox } from "@ronin/contracts";
import { CheckField, FormSection } from "./form-section.js";

const names: Record<ContainerBox, string> = {
  uptime: "Uptime (or time since stop)",
  health: "Health (or exit code)",
  version: "Version",
  created: "Created",
  ports: "Ports",
  cpu: "CPU",
  memory: "RAM",
  network: "Network",
  disk: "Disk I/O",
};

/** spec14 FR6a: which info boxes a container card shows, kept in the fixed order. */
export function ContainerBoxFields({
  value,
  onChange,
}: {
  value: ContainerBox[];
  onChange: (boxes: ContainerBox[]) => void;
}) {
  return (
    <FormSection
      title="Info boxes"
      hint="The card shows as many as fit; make it wider or taller for more."
    >
      <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 sm:grid-cols-3">
        {Boxes.options.map((box) => (
          <CheckField
            key={box}
            label={names[box]}
            checked={value.includes(box)}
            // Kept in the fixed order (FR6a).
            onChange={(on) =>
              onChange(Boxes.options.filter((b) => (b === box ? on : value.includes(b))))
            }
          />
        ))}
      </div>
    </FormSection>
  );
}
